import { createTransform } from 'redux-persist'
import { fromJS, isCollection } from 'immutable'

const immutableKeys = ['user', 'appSettings', 'configuration', 'location', 'wallet']

const immutableTransform = createTransform(
  (inboundState, key) =>
    immutableKeys.includes(key) && isCollection(inboundState)
      ? inboundState.toJS()
      : inboundState,

  (outboundState, key) =>
    immutableKeys.includes(key) && outboundState && typeof outboundState === 'object'
      ? fromJS(outboundState)
      : outboundState
)

export default immutableTransform
